import type { ColDef } from 'ag-grid-community';

export type TypeDeliveryOperationInfoRow = {
  inboundHub: string;
  inboundSchedule: string;
};

/**
 * [화주사 정보 관리 > 화주사 정보] '배송운영 정보' 테이블 컬럼 정의
 */
const getVenderConfirmDeliveryOperationInfoColumnDefs = () => {
  const columnDefs: ColDef<TypeDeliveryOperationInfoRow>[] = [
    {
      field: 'inboundHub',
      headerName: '입고Hub',
      width: 200,
    },
    {
      field: 'inboundSchedule',
      headerName: '입고 스케줄',
      flex: 1,
    },
  ];

  return { columnDefs };
};

export default getVenderConfirmDeliveryOperationInfoColumnDefs;
